import useColors from "../../../../api/hooks/useColors";
import CustomToolTip from "../../../../components/CustomTooltip";
import StatusChip from "../../../../components/chips/StatusChip";
import { ControlStatus } from "../../../../utils/constants";
import { getStatusColor } from "./EntitiesSection/utils";

export default function ControlStatusIndicator({ status }) {
  const colors = useColors();

  return (
    <>
      <CustomToolTip
        title={"All current entities are excluded from this gap"}
        placement="top"
        disableHoverListener={status !== ControlStatus.EXCLUDED}
      >
        <StatusChip
          circleColor={getStatusColor(status, colors)}
          label={status}
        />
      </CustomToolTip>
    </>
  );
}
